import React from "react";
import { StyledTooltip, StyledTooltipContent } from "./CommonStyles";

const Tooltip = ({ text, children }) => {
  return (
    <StyledTooltip>
      {children}
      <StyledTooltipContent>{text}</StyledTooltipContent>
    </StyledTooltip>
  );
};

export default Tooltip;